import React, { useMemo } from "react";
import { Autocomplete, TextField, FormControl } from "@mui/material";
import esArray from "src/general_components/functionEsArray";

export const SelectorProfilesMUI = ({ perfiles, value, onChange }) => {
  const options = useMemo(() => esArray(perfiles), [perfiles]);

  const selected = options.find((p) => p.id === value) || null;

  return (
    <FormControl sx={{ width: "100%" }}>
      <Autocomplete
        value={selected}
        onChange={(e, newValue) => {
          if (!newValue) return onChange("");
          onChange(newValue.id);
        }}
        options={options}
        getOptionLabel={(option) => `${option.id} - ${option.detalle}`}
        renderInput={(params) => (
          <TextField {...params} label="Perfil *" />
        )}
      />
    </FormControl>
  );
};
